import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface RulesAndRestrictionsContainerProps {
  userId: string;
  propertyId: string;
}

export const RulesAndRestrictionsContainer: React.FC<
  RulesAndRestrictionsContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Pet Policy"
        fieldKey="rulesAndRestrictions.petPolicy"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Rental Restrictions"
        fieldKey="rulesAndRestrictions.rentalRestrictions"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Smoking Restrictions"
        fieldKey="rulesAndRestrictions.smokingRestrictions"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Other Restrictions"
        fieldKey="rulesAndRestrictions.otherRestrictions"
      />
    </Box>
  );
};
